import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import sqlFormatter from "sql-formatter"
import { Alert, Container, Row, Col, ListGroupItem, ListGroup, Button, Card, CardHeader, CardBody} from "shards-react";
import { Redirect, Link } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import auth from '../../components/common/Auth';
import history from '../../history';


const parentUrl = process.env.REACT_APP_RE_URL;


class Crud extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      loading: true,
      action: "",
      alertVisible: true,
      crud: [],
      apiActionErr: null,
      apiErr: null
    }
  }

  handleChange = (field, event) => {
    this.setState({
      [field]: event.target.value
    })
  }

  handleAction = (event) => {

     if(this.state.action.trim() !== ""){
        window.location.href = this.state.action;
     }

  }

  _getCrud() {
    var idCrud = this.props.idCrud;
    const token = auth.getAccessToken()
    const url = parentUrl + "/smre/1.0/entity_cruds/"+idCrud;
    const self = this;

    axios.get(
      url,
      {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization" : "Bearer "+token
        }
      }
    ).then(function (response) {

      var crud = response.data.entity_cruds;
      crud.sqlFormatter = sqlFormatter.format(crud.crud_sql);

      self.setState({
        loading: false,
        crud: crud,
      })

    }).catch(function (error) {
        self.setState({
            crud: []
        })
    });
  }

  componentDidMount () {
    this._getCrud();
  }

  retry = () => {
    this.setState({
      apiErr: null,
      alertVisible: true,
      loading: true,
      account: null
    }, () => this._getAccounts())
  }

  dismiss = () => {
    this.setState({ alertVisible: false });
  }

  goBack = () => {
    history.goBack();
  }

  render () {
    const crud = this.state.crud

    // if(auth.isAuthenticated()){
        if (this.state.loading) {
          return (
            <div>
              <Container fluid>
                <br/>
                <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
                </div>
              </Container>
            </div>
          )
        }

        if (this.state.apiErr) {
          return (
            <div>
              <Container fluid className="main-content-container px-4 pb-4">
                <div className="error">
                  <div className="error__content">
                    <h2>404</h2>
                    <h3>{this.context.t('This page is not available')}</h3>
                    <p>{this.context.t('It is possible that the link you followed is broken or the page has been deleted.')}</p>
                    <Link to="/">
                    <Button pill>&larr; {this.context.t('Go Back')}</Button>
                    </Link>
                  </div>
                </div>
              </Container>
            </div>
          )
        }

        let error
        if (this.state.apiActionErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiActionErr.message}</Alert></Container>
        }

        return (
          <div>

            {error}

            <Container fluid className="main-content-container px-4">
                <br/>
                <br/>
                <Row>
                  <Col lg="4">
                      <Card small className="mb-4 pt-3">
                        <CardHeader className="text-center">
                          <div className="mb-3 mx-auto">
                            <i className="material-icons blue-text" style={{fontSize: "64px"}}>clear_all</i>
                          </div>
                          <h4 className="mb-0">{crud.crud_type}</h4>
                        </CardHeader>
                        <ListGroup flush>
                          <ListGroupItem className="p-4 text-center">
                              <Link to={'/cruds/edit/'+crud.id}>
                                  <Button pill outline size="sm" className="mb-2 ">
                                    <i className="material-icons mr-1">edit</i> {this.context.t('Edit')}
                                  </Button>
                              </Link>
                          </ListGroupItem>
                        </ListGroup>
                      </Card>
                  </Col>
                  <Col lg="8">
                    <Card small className="mb-4">
                      <CardHeader className="border-bottom">
                        <h6 className="m-0" style={{ float: "left"}}>{this.context.t('Details')}</h6>
                        <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px"}}  onClick={e => {this.goBack()}}>arrow_back</i>
                      </CardHeader>
                      <CardBody className="pt-0">
                          <Row className="border-bottom py-2 bg-light">
                              <Col sm="12" className="mb-2 mb-sm-0" style={{paddingTop: "7px"}}>
                                   <b> <i className="material-icons">access_time</i> {moment(crud.created_at).format(this.context.t("YYYY-MM-DD HH:mm"))}</b>
                              </Col>
                          </Row>
                          <br/>
                            <Row>
                              <Col>
                                <pre>
                                {crud.sqlFormatter}
                                </pre>
                              </Col>
                            </Row>
                      </CardBody>

                    </Card>

                  </Col>
                </Row>

            </Container>
            <br/>
            <br/>
          </div>

        )
    // }else{
    //     return <Redirect to='/' />
    // }
  }
}

Crud.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(Crud)
